<script>
import Panel from '@phoenix/mixins/components/common/Panel';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [Panel],

  props: {
    bodyDataCy: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      defaultOptions: {
        openClass: 'is-active',
      },
    };
  },

  computed: {
    _classes() {
      return ['sgphx-panel', { 'sgphx-panel--reverse': this.reverse }, ...this.classes];
    },

    _headerClasses() {
      return ['sgphx-panel__header', ...this.headerClasses];
    },

    _contentClasses() {
      return ['sgphx-panel__content sgphx-panel__content--boxed', 'flex-1', ...this.contentClasses];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="sgphx-panel__overlay" :data-panel-close="id" tabindex="-1"></div>

    <div class="sgphx-panel__container" role="dialog" aria-modal="true">
      <div :class="_headerClasses">
        <h1 v-if="hasTitle" class="sgphx-panel__header__title sgphx-h5">
          {{ title }}
        </h1>

        <button
          class="sgphx-btn sgphx-btn--icon-only sgphx-btn--icon"
          type="button"
          :data-panel-close="id"
          aria-expanded="false"
        >
          <span class="sgphx-btn__icon sgphx-btn__icon--start">
            <phx-icon icon="close" class="sgphx-icon sgphx-icon--sm" :title="$t('Modal.closeDialog')" />
          </span>
        </button>
      </div>

      <div class="sgphx-panel__body" :data-cy="bodyDataCy">
        <div :class="_contentClasses">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
